var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1600 1600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,406.091l0,779.696l818.391,414.213l-818.391,-1193.91Z",
    style: {
      fill: "#5aac45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.391,-0l-818.391,406.091l818.391,1193.91l781.609,-414.213l-781.609,-1185.79Z",
    style: {
      fill: "#78b55f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.92,792.736l259.078,393.051l0,-779.696l-259.078,386.645Z",
    style: {
      fill: "#3e863d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.92,792.736l-522.531,-792.736l781.609,406.091l-259.078,386.645Z",
    style: {
      fill: "#6da45f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1185.79l265.034,-393.051l553.357,807.264l-818.391,-414.213Z",
    style: {
      fill: "#3e863d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.9c5697e14d12140e7636eb3b985c27b5.svg";
export { ForwardRef as ReactComponent };